import { formatDayKey, dayKeyToDate } from './tz';

const DAY_MS = 24 * 60 * 60 * 1000;

// The last instant an event actually occupies. Ends that land exactly on a day
// boundary belong to the previous day: all-day events carry an exclusive end
// date, and a timed event ending at 00:00 does not reach into the next day.
function lastInstant(event) {
  const end = event.end.getTime();
  const endsOnDayBoundary =
    formatDayKey(new Date(end)) !== formatDayKey(new Date(end - 1));
  if (!endsOnDayBoundary) return end;
  return Math.max(end - 1, event.start.getTime());
}

// Every calendar day (in DISPLAY_TZ) an event touches, in order.
export function eventDayKeys(event) {
  const startKey = formatDayKey(event.start);
  const endKey = formatDayKey(new Date(lastInstant(event)));
  if (startKey === endKey) return [startKey];

  const keys = [];
  let cursor = dayKeyToDate(startKey);
  const last = dayKeyToDate(endKey);
  while (cursor <= last) {
    keys.push(formatDayKey(cursor));
    cursor = new Date(cursor.getTime() + DAY_MS);
  }
  return keys;
}
